import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import "./index.css";
import "./Content_Layout.css";
import "./ArticleGallery.css";
import { i18n, init as i18nInit } from "./i18n";

(async function () {

  await i18nInit();
  document.title = i18n("app.title");
  const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <BrowserRouter basename={baseUrl} >
      < App />
    </BrowserRouter>
  );
})();